// Copyright (c) Docugami, Inc. All rights reserved.

import { createSelector } from "@reduxjs/toolkit";
import { getFileUxName } from "components/file_management/file_helpers";
import { VersionedFolderIdInput } from "networking/api";
import { AppState } from "store";

export const createSelectFolderIdsWithCpmlFromFilePaths = () => createSelector(
    (state: AppState, paths: string[]) => state.documents.indexed,
    (state: AppState, paths: string[]) => paths,
    (indexedDocuments, paths): VersionedFolderIdInput[] => {
        const documents = Object.values(indexedDocuments);
        const clusterDocuments = paths.map(x => documents.find(document => 
            document.clusterDocument.fileId === x)?.clusterDocument);

        const items: VersionedFolderIdInput[] = [];
        for (const document of clusterDocuments) {
            if (!!document?.hasCpml) {
                items.push({
                    folderId: document.folderId,
                    fileName: getFileUxName(document.filename, true)
                })
            }
        }

        return items;
    }
)
